import { Base64 } from './file';

class Upload {
    private locales: any = {
        'en-US': {
            size: 'Upload file size should not exceed 30M',
            pdf: 'Only PDF files can be uploaded, no more than 8M',
            excel:'Only XLS or XLSX files can be uploaded, no more than 8M',
            clueExcel: 'Only XLS or XLSX files can be uploaded, no more than 500K',
            disPressSize: 'Upload file size should not exceed 3M',
            type: 'Only upload files in image format',
            error: 'Upload error',
            reload: 'Reload',
            loading: 'Loading',
            unUpload: 'Not uploaded',
            upload: 'upload'
        },
        'zh-CN': {
            size: '上传文件大小不得超过30M',
            pdf: '只允许上传PDF文件，不可大于8M',
            excel: '只允许上传XLS或XLSX文件，不可大于8M',
            clueExcel: '只允许上传XLS或XLSX文件，不可大于500K',
            disPressSize: '上传文件大小不得超过3M',
            type: '只能上传图片格式的文件',
            error: '上传错误',
            reload: '重新上传',
            loading: '正在加载',
            unUpload: '未上传',
            upload: '上传'
        },
        'zh-TW': {
            size: '上傳文件大小不得超過30M',
            pdf: '只允許上傳PDF文件，不可大於8M',
            excel: '只允許上傳XLS或XLSX文件，不可大於8M',
            clueExcel: '只允許上傳XLS或XLSX文件，不可大於500K',
            disPressSize: '上傳文件大小不得超過3M',
            type: '只能上傳圖片格式的文件',
            error: '上傳錯誤',
            reload: '重新上傳',
            loading: '正在加載',
            unUpload: '未上傳',
            upload: '上傳'
        },
        'ko-KR': {
            size: '업로드 파일 크기는 4M을 초과해서는 안됩니다.',
            pdf: 'PDF 파일 만 업로드, 8M 이상',
            excel: 'XLS, XLSX 파일 만 업로드, 8M 이상',
            clueExcel: 'XLS, XLSX 파일 만 업로드, 500K 이상',
            disPressSize: '업로드 파일 크기는 3M을 초과해서는 안됩니다.',
            type: '영수증을 업로드하세요.',
            error: 'U업로드 오류',
            reload: '다시 업로드',
            loading: '로드 중',
            unUpload: '업로드되지 않음',
            upload: '업로드'
        },
        'ja-JP': {
            size: 'アップロードファイルのサイズは30Mを超えてはいけません',
            pdf: 'PDFファイルのみをアップロードします。8M以下',
            excel: 'XLS, XLSXファイルのみをアップロードします。8M以下',
            clueExcel: 'XLS, XLSXファイルのみをアップロードします。500K以下',
            disPressSize: 'アップロードファイルのサイズは3Mを超えてはいけません',
            type: '画像形式のファイルのみアップロードできます',
            error: 'アップロードエラー',
            reload: '再アップロード',
            loading: 'ロード中',
            unUpload: 'アップロードされていません',
            upload: 'upload'
        },
        'vi-VN': {
            size: 'Kích thước tệp tải lên không được vượt quá 30 triệu',
            pdf: 'Chỉ tải lên tệp PDF, không quá 8 triệu',
            excel: 'Chỉ tải lên tệp XLS, XLSX, không quá 8 triệu',
            clueExcel: 'Chỉ tải lên tệp XLS, XLSX, không quá 500K',
            disPressSize: 'Kích thước tệp tải lên không được vượt quá 3M',
            type: 'Chỉ có thể tải lên các tệp ở định dạng hình ảnh',
            error: 'Lỗi tải lên',
            reload: 'Tải lên lại',
            loading: 'Đang tải',
            unUpload: 'Không được tải lên',
            upload: 'Tải lên'
        },
        'th-TH': {
            size: 'อัพโหลดไฟล์ไม่เกิน30M',
            pdf: 'อัปโหลดไฟล์ PDF ได้ไม่เกิน 8M',
            excel: 'อัปโหลดเฉพาะไฟล์ XLS หรือ XLSX ไม่เกิน 8M',
            clueExcel: 'อัปโหลดเฉพาะไฟล์ XLS หรือ XLSX ไม่เกิน 500K',
            disPressSize: 'อัพโหลดไฟล์ไม่เกิน3M',
            type: 'อัปโหลดไฟล์รูปแบบเป็นภาพเท่านั้น',
            error: 'การอัปโหลดผิดพลาด',
            reload: 'อัปโหลดใหม่',
            loading: 'กำลังอัปโหลด',
            unUpload: 'ยังไม่ได้อัปโหลด',
            upload: 'อัปโหลด'
        },
        'in-ID': {
            size: 'Ukuran file tidak boleh lebih dari 30M',
            pdf: 'Hanya diperbolehkan mengunggah file PDF, tidak lebih dari 8M',
            excel: 'Hanya unggah file XLS atau XLSX, tidak lebih dari 8M',
            clueExcel: 'Hanya unggah file XLS atau XLSX, tidak lebih dari 500K',
            disPressSize: 'Ukuran file tidak boleh lebih dari 3M',
            type: 'Hanya unggah file dalam format gambar',
            error: 'Kesalahan unggahan',
            reload: 'Unggah ulang',
            loading: 'Sedang memuat',
            unUpload: 'Tidak diunggah',
            upload: 'Unggah'
        },
    };

    /**
     * 获取图片上传文字提示
     * @param lang
     */
    getLocales = (lang: string = 'zh-CN') => ({ ...this.locales[lang] });

    normalizeDecimalNumber = (value: number, times = 100000000000) => {
        return (Math.round(value * times) / times);
    };

    /**
     * 图像压缩
     * @param file
     * @param src
     * @param type
     * @param quality
     * @param transBg
     * @param callback
     * @deprecated
     */
    imagePress = ({ file, src, type, quality, transBg }: any, callback: Function) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const image = new Image();
        const ql = quality || 0.8;  // 默认压缩参数
        const pType = type || 'blob';
        // 最终转换图片格式(有透明背景需求则转成png格式)
        const fType = transBg ? 'image/png' : 'image/jpeg';
        image.setAttribute("crossOrigin",'Anonymous');
        image.onload = () => {
            // 限制最大宽度为1280px，等比例缩小
            if (image.width > 1280) {
                const maxWidth = 1280;
                const aspectRatio = image.width / image.height;
                const maxHeight = maxWidth / aspectRatio;
                image.width = Math.floor(Math.min(Math.max(image.width, 0), maxWidth));
                image.height = Math.floor(Math.min(Math.max(image.height, 0), maxHeight));
            }
            canvas.width = this.normalizeDecimalNumber(image.width);
            canvas.height = this.normalizeDecimalNumber(image.height);
            // jpeg格式填充白色背景
            if (!transBg) {
                ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
            ctx.drawImage(image, 0, 0, image.width, image.height);
            const url = canvas.toDataURL(fType, ql);
            pType === 'blob' &&  callback(Base64.convertToBlob(url, fType), url);
            pType === 'base64' && callback(url);
        };
        image.src = src;
    };
}

export default new Upload();
